import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/services/courses/components/CoursesListAndFilter.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/services/courses/courses.module.scss");
